import { BaseModel } from "../../lib/itn-ui-kit/data";
import { attr } from "../../lib/itn-ui-kit/data/decorators";

export default class FollowUpsFormSubmitModel extends BaseModel {
  @attr("json") question1;
  @attr("json") question2;
  @attr("json") question3;
  @attr("json") question4;
  @attr("json") question5;
  @attr("json") question6;
  @attr("json") question7;
  @attr("json") question8;
  @attr("json") question9;
  @attr("json") question10;
  @attr("json") question11;
  @attr("json") question13;
  @attr("json") question14;
  @attr("json") question15;
  @attr("json") question16;
  @attr("json") question17;
  @attr("json") question18;
  @attr("json") question19;
  @attr("json") question20;
  @attr("json") question21;
  @attr("json") question22;
  @attr("json") question23;
  @attr("json") question24;
  @attr("json") question25;
  @attr("json") question26;
  @attr("json") question27;
  @attr("json") question28;
  @attr("json") question29;
  @attr("json") question30;
  @attr("json") question31;
  @attr("json") question32;
}
